'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _UnsafeUrl = require('../utils/UnsafeUrl');

var _validHref = require('../utils/propTypes/validHref');

var _validHref2 = _interopRequireDefault(_validHref);

var _ThrowError = require('../utils/ThrowError');

var _Functions = require('../core/Functions');

var _BrowserTest = require('../utils/BrowserTest');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SHAPE_CLASSES = {
  default: '',
  circle: 'img-circle private-image--circle',
  rounded: 'img-rounded private-image--rounded',
  thumbnail: 'img-thumbnail private-image--thumbnail'
};

var OBJECT_FIT_CLASSES = {
  fill: '',
  contain: 'private-image--object-fit-contain'
};

var aspectRatioCache = {};
var measureImgAspectRatio = function measureImgAspectRatio(src) {
  if (!aspectRatioCache[src]) {
    var imgEl = document.createElement('img');
    imgEl.src = src;
    document.body.appendChild(imgEl);

    var _imgEl$getBoundingCli = imgEl.getBoundingClientRect(),
        width = _imgEl$getBoundingCli.width,
        height = _imgEl$getBoundingCli.height;

    document.body.removeChild(imgEl);
    aspectRatioCache[src] = width / height;
  }
  return aspectRatioCache[src];
};

exports.default = _react2.default.createClass({
  displayName: 'UIImage',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: {
    alt: _react.PropTypes.string.isRequired,
    bordered: _react.PropTypes.bool.isRequired,
    className: _react.PropTypes.string,
    height: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
    onError: _react.PropTypes.func,
    onLoad: _react.PropTypes.func,
    objectFit: _react.PropTypes.oneOf(Object.keys(OBJECT_FIT_CLASSES)).isRequired,
    responsive: _react.PropTypes.bool.isRequired,
    shape: _react.PropTypes.oneOf(Object.keys(SHAPE_CLASSES)).isRequired,
    src: _validHref2.default.isRequired,
    width: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      alt: '',
      bordered: false,
      objectFit: 'fill',
      responsive: true,
      shape: 'default'
    };
  },
  getInitialState: function getInitialState() {
    return {
      loadFailed: false,
      overrides: {}
    };
  },
  componentDidMount: function componentDidMount() {
    this.polyfillObjectFit();
  },
  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    // ⚠️ This condition prevents infinite loops! ⚠️
    if (prevState.overrides === this.state.overrides) {
      this.polyfillObjectFit();
    }
  },
  handleImageError: function handleImageError(evt) {
    var onError = this.props.onError;

    this.setState({
      loadFailed: true
    });
    (0, _Functions.callIfPossible)(onError, evt);
  },
  handleImageLoad: function handleImageLoad(evt) {
    var onLoad = this.props.onLoad;

    this.setState({
      loadFailed: false
    });
    this.polyfillObjectFit();
    (0, _Functions.callIfPossible)(onLoad, evt);
  },
  polyfillObjectFit: function polyfillObjectFit() {
    var _props = this.props,
        height = _props.height,
        objectFit = _props.objectFit,
        src = _props.src,
        width = _props.width;

    if ((0, _BrowserTest.isIE11)() && objectFit === 'contain' && document.body && this._img && (width || height) && !(width && height)) {
      var imgAspectRatio = measureImgAspectRatio(src);

      var _img$getBoundingClien = this._img.getBoundingClientRect(),
          renderedWidth = _img$getBoundingClien.width,
          renderedHeight = _img$getBoundingClien.height;

      if (width) {
        this.setState({
          overrides: { height: renderedWidth / imgAspectRatio }
        });
      } else {
        this.setState({
          overrides: { width: renderedHeight * imgAspectRatio }
        });
      }
    }
  },
  getClassName: function getClassName(_ref) {
    var bordered = _ref.bordered,
        className = _ref.className,
        objectFit = _ref.objectFit,
        responsive = _ref.responsive,
        shape = _ref.shape;

    return (0, _reactUtils.classNames)('private-image', SHAPE_CLASSES[shape], OBJECT_FIT_CLASSES[objectFit], className, {
      'img-responsive private-image--responsive': responsive,
      'image-load-failed': this.state.loadFailed,
      'private-image--bordered': bordered
    });
  },
  render: function render() {
    var _this = this;

    var _props2 = this.props,
        bordered = _props2.bordered,
        className = _props2.className,
        height = _props2.height,
        objectFit = _props2.objectFit,
        responsive = _props2.responsive,
        shape = _props2.shape,
        src = _props2.src,
        width = _props2.width,
        rest = _objectWithoutProperties(_props2, ['bordered', 'className', 'height', 'objectFit', 'responsive', 'shape', 'src', 'width']);

    if ((0, _UnsafeUrl.isUnsafeUrl)(src)) {
      (0, _ThrowError.throwErrorAsync)(new Error('UIImage: Detected XSS attempt! src="' + src + '"'));
    }

    var overrides = this.state.overrides;


    return _react2.default.createElement('img', _extends({}, rest, {
      className: this.getClassName({
        bordered: bordered,
        className: className,
        objectFit: objectFit,
        responsive: responsive,
        shape: shape
      }),
      height: height == null ? overrides.height : height,
      key: src,
      onError: this.handleImageError,
      onLoad: this.handleImageLoad,
      ref: function ref(_ref2) {
        _this._img = _ref2;
      },
      src: (0, _UnsafeUrl.isUnsafeUrl)(src) ? null : src,
      width: width == null ? overrides.width : width
    }));
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/image/UIImage.js
// module id = 46
// module chunks = 0